import { Tooltip, TooltipProps } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { C1DarkTheme } from 'c1ui/theme/C1Theme'
import { FC } from 'react'

export const maxTooltipWidth = '450px'

export const C1Tooltip: FC<TooltipProps> = ({ children, title: _title, ...props }) => {
    const title = <ThemeProvider theme={C1DarkTheme}>{_title}</ThemeProvider>

    return <Tooltip {...props} title={title}>{children}</Tooltip>
}
